import axios from 'axios';

export function sendLetterToArchive(id) {
    return axios({
        method: 'put',
        url: `/api/v1/mails/mail/${id}/archive`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function sendRefNumber(id, { refNo, requestId }) {
    return axios({
        method: 'put',
        url: `/api/v1/mails/mail/${id}`,
        data: {
            refNo,
            requestId,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getLetters(pagination) {
    return axios({
        method: 'GET',
        url: `/api/v1/mails${pagination.archive ? '/archiveLetters' : ''}`,
        withCredentials: true,
        params: {
            eh: pagination.eh,
            page: pagination.page,
            limit: pagination.limit,
            search: pagination.search,
            typeMail: pagination.typeMail,
            statusMail: pagination.statusMail,
            withAttachments: pagination.withAttachments,
            dateStart: pagination.dateStart,
            dateEnd: pagination.dateEnd,
            brokerMails: pagination.brokerMails,
            listeners: pagination.listeners,
            showUniqueBrokerMails: pagination.showUniqueBrokerMails,
            isNosa: pagination.isNosa,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getLetter(id) {
    return axios({
        method: 'GET',
        url: `/api/v1/mails/mail/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateLetter(letter, server = '') {
    const urlServer = server === 'standart' || server === '' ? '' : `http://${server}`;

    return axios({
        method: 'PUT',
        url: `${urlServer}/api/v1/mails/update/${letter._id}`,
        data: letter,
        // withCredentials: urlServer !== '',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => (response.response ? response.response.data : response));
}

export function sendEmailsFailedToNew(failedEmailsAmount, total) {
    return axios({
        method: 'patch',
        url: '/api/v1/mails/failedToNew',
        data: {
            amount: failedEmailsAmount,
            total,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => (response.response ? response.response.data : response));
}

export function sendEmailsToNew(emailsAmount, emailStatus, total) {
    return axios({
        method: 'patch',
        url: '/api/v1/mails/emailsToNew',
        data: {
            amount: emailsAmount,
            total,
            emailStatus,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => (response.response ? response.response.data : response));
}

export function saveEmailsToDev(emailsStatus, emailsAmount) {
    return axios({
        method: 'post',
        url: '/api/v1/mails/saveMultipleToDev',
        data: {
            emailsStatus,
            amount: emailsAmount,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => (response.response ? response.response.data : response));
}

export function sendToRabbit(idsArr) {
    return axios({
        method: 'patch',
        url: '/api/v1/mails/emailsToNew',
        data: {
            idsArr,
        },
        withCredentials: true,
    })
        .then(respose => respose.data)
        .catch(response => (response.response ? response.response.data : response));
}

export function saveAsSpam(id) {
    return axios({
        method: 'put',
        url: `/api/v1/mails/markSpam/${id}`,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function fetchPredictorType(mailData) {
    return axios({
        method: 'post',
        url: '/api/v1/mails/predictor-type',
        data: mailData,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/letters.js